// Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, clearIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { startupPersistenceClear } from './session/sessionCleanup';
import { postSessionEvent } from './session/sessionChannel';

const firebaseConfig = {
  apiKey: "AIzaSyBVgyti1bXUbptZfT3uKh63qo1q6xVArtM",
  authDomain: "firmassist-19248.firebaseapp.com",
  projectId: "firmassist-19248",
  storageBucket: "firmassist-19248.firebasestorage.app",
  messagingSenderId: "617176814381",
  appId: "1:617176814381:web:d35b7c0b493ecb1265f9a4"
};

const app = initializeApp(firebaseConfig);

// Auth FIRST — must never be blocked by App Check failures
export const auth = getAuth(app);

// Firestore with offline persistence
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

// Session cleanup (2026-10-06): if a previous logout / firm change could not
// clear the local Firestore cache (another tab held it), retry now — before
// this instance starts, the only other moment the SDK allows it. Capped.
startupPersistenceClear({ db, clearIndexedDbPersistence, post: postSessionEvent });

export const storage = getStorage(app);

// App Check — DISABLED
// reCAPTCHA v3 integrity hash changes cause auth/network-request-failed errors.
// App Check was in monitoring mode (not enforced) — removing it has zero impact
// on security or functionality. Can be re-enabled later if enforcement is needed.

export default app;
